import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Template1 from './pages/template_1';
import Chelsea from './pages/chelsea';
import SignUp from './pages/SignUp';
import Success from './pages/Success';
import EmailVerification from './pages/EmailVerification';
import VerificationSuccess from './pages/VerificationSuccess';
import GoogleCallback from './pages/GoogleCallback';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PasswordResetSuccess from './pages/PasswordResetSuccess';
import Download from './pages/Download';
import LoadingDemo from './components/LoadingDemo';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/template_1" element={<Template1 />} />
        <Route path="/chelsea" element={<Chelsea />} />
        <Route path="/sign-up/:creatorId" element={<SignUp />} />
        <Route path="/:creatorId/success" element={<Success />} />
        <Route path="/auth/verify" element={<EmailVerification />} />
        <Route path="/auth/verification-success" element={<VerificationSuccess />} />
        <Route path="/auth/google-callback" element={<GoogleCallback />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/auth/password-reset-success" element={<PasswordResetSuccess />} />
        <Route path="/download" element={<Download />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/loading-demo" element={<LoadingDemo />} />
      </Routes>
    </Router>
  );
};

export default App; 